module.exports = __webpack_public_path__ + "img/index-section6-friend1_a.5ba3125f.svg";